export enum SubtraceEventKind {
  ClickhouseError = "ClickhouseError",
  CreateTunnelFailure = "CreateTunnelFailure",
  EmailSubmitError = "EmailSubmitError",
  GetSelfFailure = "GetSelfFailure",
  QueryEvaluated = "QueryEvaluated",
  TunnelError = "TunnelError",
  TunnelResultDecoded = "TunnelResultDecoded",
  TunnelWebSocketClosed = "TunnelWebSocketClosed",
  UncaughtAppBoundaryError = "UncaughtAppBoundaryError",
}
